function expandCollapse(target: Element, clicked: Element, classes: { collapsed: string; expanded: string }): void {
    const clickedParent = clicked.parentElement;

    target.classList.remove(classes.collapsed);
    target.classList.add(classes.expanded);
    clicked.classList.add('active');

    if (clickedParent) {
        clickedParent.classList.add('child-expanded');
    }
}

function collapseCollapse(target: Element, clicked: Element, classes: { collapsed: string; expanded: string }): void {
    const clickedParent = clicked.parentElement;

    target.classList.remove(classes.expanded);
    target.classList.add(classes.collapsed);
    clicked.classList.remove('active');

    if (clickedParent) {
        clickedParent.classList.remove('child-expanded');
    }
}

function collapse(target: Element | null, clicked: Element, event: MouseEvent): void {
    if (!target) {
        return;
    }

    event.preventDefault();

    const classes = {
        collapsed: target.dataset.collapsedClass || 'collapsed',
        expanded: target.dataset.expandedClass || 'expanded',
    };

    const accordion = clicked.dataset.accordion;

    if (accordion) {
        const accordions = document.querySelectorAll(`[data-accordion="${accordion}"]`);

        accordions.forEach((item: HTMLElement) => {
            if (item !== clicked) {
                const target = document.querySelector(item.dataset.collapse);

                if (target) {
                    collapseCollapse(target, item, classes);
                }
            }
        });
    }

    if (target.classList.contains(classes.collapsed)) {
        expandCollapse(target, clicked, classes);
    } else {
        collapseCollapse(target, clicked, classes);
    }
}

function bindCollapseExpandLogic() {
    window.addEventListener('DOMContentLoaded', () => {
        const collapses = document.querySelectorAll('[data-collapse]');

        collapses.forEach((item: HTMLElement) => {
            item.addEventListener('click', (event) => {
                const target = document.querySelector(item.dataset.collapse);

                collapse(target, item, event);
            });
        });
    });
}

export default function collapseInit() {
    bindCollapseExpandLogic();
}
